import { ref } from "vue";
import { defineStore } from "pinia";

import type { DsToastStoredNotification } from "../../helpers/toast/DsNotifier.types";

export const useDsToastNotifierStore = defineStore("ds-toast-notifier", () => {
  const notifications = ref<DsToastStoredNotification[]>([]);

  const addNotification = (notification: DsToastStoredNotification): void => {
    notifications.value.push(notification);
  };

  const deleteNotification = (id: number): void => {
    const index = notifications.value.findIndex((notification) => {
      return notification.id === id;
    });
    //If index found, delete the notification
    if (index !== -1) {
      notifications.value.splice(index, 1);
    }
  };

  return {
    notifications,
    addNotification,
    deleteNotification,
  };
});
